/**
 * Tracks an event by adding it to the global dataLayer object.
 *
 * @param {string} event - The name of the event to track.
 * @param {Object} [additionalData={}] - An optional object containing additional data to include with the event.
 * @return {void}
 */
export function trackEvent(event, additionalData = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...additionalData
  });
}